import React from 'react';

import { UiTypography } from '@/components/ui/Typography';
import { webSubscriptionsModule } from '@/modules/subscriptions';
import {
  StripeV2CoinsPrice,
  StripeV2SubscriptionPrice,
} from '@/services/stripe/dto';

import {
  PaymentDescriptionRowStyles,
  PaymentDescriptionStyles,
} from './CombinedPaymentDescription.styles.ts';

export const CombinedPaymentDescription: React.FC<{
  selectedPlan: StripeV2SubscriptionPrice;
  selectedCoinPlan?: StripeV2CoinsPrice | null;
}> = ({ selectedPlan, selectedCoinPlan }) => {
  const subscriptionData = webSubscriptionsModule.getPlanConfig(selectedPlan);

  // Calculate subscription discount
  const subscriptionSaleAmount =
    subscriptionData.basePriceWithoutSale - subscriptionData.basePrice;
  const subscriptionSale = subscriptionSaleAmount.toFixed(2);

  // Calculate total price: original price - discount + coins
  const coinsPrice = selectedCoinPlan?.price || 0;
  const totalPrice = subscriptionData.basePrice + coinsPrice;

  return (
    <PaymentDescriptionStyles>
      {/* Subscription row */}
      <PaymentDescriptionRowStyles>
        <UiTypography variant="body-medium">
          {selectedPlan.label} Plan
        </UiTypography>
        <UiTypography variant="body-medium">
          ${subscriptionData.basePriceWithoutSale}
        </UiTypography>
      </PaymentDescriptionRowStyles>

      {/* Subscription discount */}
      {subscriptionSale !== '0.00' && (
        <PaymentDescriptionRowStyles>
          <UiTypography variant="body-medium">Plan Discount</UiTypography>
          <UiTypography variant="body-medium" color="danger">
            -${subscriptionSale}
          </UiTypography>
        </PaymentDescriptionRowStyles>
      )}

      {/* Coins row (if selected) */}
      {selectedCoinPlan && (
        <PaymentDescriptionRowStyles>
          <UiTypography variant="body-medium">
            {selectedCoinPlan.label}
          </UiTypography>
          <UiTypography variant="body-medium">
            ${selectedCoinPlan.price}
          </UiTypography>
        </PaymentDescriptionRowStyles>
      )}

      {/* Coins discount (if selected) */}
      {selectedCoinPlan &&
        selectedCoinPlan.original_price > selectedCoinPlan.price && (
          <PaymentDescriptionRowStyles>
            <UiTypography variant="body-medium">Coins Discount</UiTypography>
            <UiTypography variant="body-medium" color="danger">
              -$
              {(
                selectedCoinPlan.original_price - selectedCoinPlan.price
              ).toFixed(2)}
            </UiTypography>
          </PaymentDescriptionRowStyles>
        )}

      {/* Total */}
      <PaymentDescriptionRowStyles>
        <UiTypography variant="title-large">Total</UiTypography>
        <UiTypography variant="title-large">
          ${totalPrice.toFixed(2)}
        </UiTypography>
      </PaymentDescriptionRowStyles>
    </PaymentDescriptionStyles>
  );
};
